import classNames from "classnames";
import { graphql, Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";

const BannerPromoCM = ({ data, position }) => {
  const bpLink = data.cta?.bpCtaLink;

  return (
    (position === "pdp" &&
      //   (data.bpPdpPosition.value[0] === "image background" ? (
      //     bpLink ? (
      //       <Link
      //         to={bpLink}
      //         target={data.bpCtaLabel?.content?.bpCtaTarget?.value}
      //         className=""
      //         rel="noreferrer"
      //       >
      //         <div className="product-detail__promo-image-wrapper product-detail__promo-image-wrapper--text-overlay">
      //           <div
      //             className="product-detail__promo-title"
      //             dangerouslySetInnerHTML={{ __html: data.bpTitle?.value }}
      //           ></div>
      //           <GatsbyImage
      //             className="product-detail__promo-image"
      //             loading="eager"
      //             image={getImage(data.bpImage.node)}
      //             alt={data.bpImage?.value?.description || ""}
      //           />
      //         </div>
      //       </Link>
      //     ) : (
      //       <div className="product-detail__promo-image-wrapper product-detail__promo-image-wrapper--text-overlay">
      //         <div
      //           className="product-detail__promo-title"
      //           dangerouslySetInnerHTML={{ __html: data.bpTitle?.value }}
      //         ></div>
      //         <GatsbyImage
      //           className="product-detail__promo-image"
      //           loading="eager"
      //           image={getImage(data.bpImage.node)}
      //           alt={data.bpImage?.value?.description || ""}
      //         />
      //       </div>
      //     )
      // ) :
      (bpLink ? (
        <Link to={bpLink} target={data.cta?.bpCtaTarget} className="" rel="noreferrer">
          <div
            className={classNames(
              "d-flex flex-row justify-content-space-between align-items-center text-center"
              //data.bpPdpPosition.value[0] === "image sx" && "flex-row-reverse"
            )}
          >
            <div
              className={classNames(
                "px-3 w-100 d-none"
                //data.bpPdpPosition.value[0] === "full image" && "d-none"
              )}
            >
              <div
                className="product-detail__promo-title"
                dangerouslySetInnerHTML={{ __html: data.bpTitle }}
              ></div>
            </div>
            <div className="product-detail__promo-image-wrapper">
              <GatsbyImage
                className="product-detail__promo-image"
                loading="eager"
                image={getImage(data.bpImage.node)}
                alt={data.bpImage?.value?.description || ""}
              />
            </div>
          </div>
        </Link>
      ) : (
        <div
          className={classNames(
            "d-flex flex-row justify-content-space-between align-items-center text-center"
            //data.bpPdpPosition?.[0] === "image sx" && "flex-row-reverse"
          )}
        >
          <div
            className={classNames(
              "px-3 w-100 d-none"
              //data.bpPdpPosition?.[0] === "full image" && "d-none"
            )}
          >
            <div
              className="product-detail__promo-title"
              dangerouslySetInnerHTML={{ __html: data?.bpTitle }}
            ></div>
          </div>
          <div className="product-detail__promo-image-wrapper">
            <GatsbyImage
              className="product-detail__promo-image"
              loading="eager"
              image={getImage(data.bpImage.node)}
              alt={data.bpImage?.value?.description || ""}
            />
          </div>
        </div>
      ))) ||
    (position === "plp" && (
      <div
        className={classNames(
          "prodotti__card prodotti__card--promo d-flex flex-column pt-0",
          bpLink && !data.cta?.bpCtaLabel && "pb-0"
        )}
      >
        <div className="prodotti__img-wrapper h-100 position-relative mb-auto">
          {bpLink && !data.cta?.bpCtaLabel ? (
            <Link to={bpLink} target={data.cta?.bpCtaTarget} rel="noreferrer">
              <GatsbyImage
                className="prodotti__img-promo"
                loading="eager"
                image={getImage(data.bpImage.node)}
                alt={data.bpImage?.value?.description || ""}
              />
            </Link>
          ) : (
            <GatsbyImage
              className="prodotti__img-promo"
              loading="eager"
              image={getImage(data.bpImage.node)}
              alt={data.bpImage?.value?.description || ""}
            />
          )}
        </div>
        {((bpLink && data.cta?.bpCtaLabel) ||
          data.bpTitle ||
          data.bpSubtitle ||
          data.bpAbstract) && (
          <div>
            <div className="prodotti__data mb-3 mt-4">
              {data.bpTitle && (
                <h2 className="prodotti__title heading-xs-bold mb-2">
                  <span dangerouslySetInnerHTML={{ __html: data.bpTitle }}></span>
                </h2>
              )}
              {data.bpSubtitle && (
                <h3 className="prodotti__subTitle heading-xs-medium">
                  <span dangerouslySetInnerHTML={{ __html: data.bpSubtitle }}></span>
                </h3>
              )}
              {data.bpAbstract && (
                <div className="mt-4">
                  <p
                    className="prodotti__desc text-xs-medium"
                    dangerouslySetInnerHTML={{ __html: data.bpAbstract }}
                  ></p>
                </div>
              )}
            </div>
            {bpLink && data.cta?.bpCtaLabel && (
              <div className="prodotti__pricing border-0 mt-auto">
                <div className="prodotti__actions ">
                  <Link
                    to={bpLink}
                    target={data.cta?.bpCtaTarget}
                    className="prodotti__btn-wtb button secondary mt-3"
                    rel="noreferrer"
                  >
                    {data.cta?.bpCtaLabel}
                  </Link>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    )) ||
    (position === "blog" && (
      <>
        <div
          className={classNames(
            "container-fluid mb-5 d-none",
            data.bpPdpPosition?.[0] === "image background" && "d-md-block"
          )}
        >
          <div className="row d-flex px-3 justify-content-center">
            <div className="col-12 banner-promo-blog-image-wrapper banner-promo-blog-image-wrapper--text-overlay">
              <div className="banner-promo-blog-text m-5 text-align-left">
                <h2 className="banner-promo-blog__title mb-2">
                  <span dangerouslySetInnerHTML={{ __html: data.bpTitle }}></span>
                </h2>
                {data.bpSubtitle && (
                  <h3 className="banner-promo-blog__subTitle">
                    <span dangerouslySetInnerHTML={{ __html: data.bpSubtitle }}></span>
                  </h3>
                )}
                {data.bpAbstract && (
                  <div className="mt-4">
                    <p
                      className="banner-promo-blog__desc"
                      dangerouslySetInnerHTML={{ __html: data.bpAbstract }}
                    ></p>
                  </div>
                )}
                <Link
                  to={bpLink}
                  target={data.cta?.bpCtaTarget}
                  className="btn-link mt-3"
                  rel="noreferrer"
                >
                  {data.cta?.bpCtaLabel}
                </Link>
              </div>
              <GatsbyImage
                className="prodotti__img-promo"
                loading="eager"
                image={getImage(data.bpImage.nodeBackground)}
                alt={data.bpImage?.value?.description || ""}
              />
            </div>
          </div>
        </div>
        <div
          className={classNames(
            "container-fluid mb-5",
            data.bpPdpPosition?.[0] === "image background" && "d-block d-md-none"
          )}
        >
          <div
            className={classNames(
              "row px-3 d-flex flex-column flex-md-row justify-content-center",
              data.bpPdpPosition?.[0] === "image sx" && "flex-column-reverse flex-md-row-reverse"
            )}
          >
            <div
              className={classNames(
                "banner-promo-blog__wrapper",
                getImage(data.bpImage.node) ? "col-12 col-md-6" : "col-12",
                getImage(data.bpImage.node) && data.bpPdpPosition?.[0] === "full image"
                  ? "d-none"
                  : "d-flex flex-column justify-content-center"
              )}
            >
              <div>
                <h2 className="banner-promo-blog__title mb-2">
                  <span dangerouslySetInnerHTML={{ __html: data.bpTitle }}></span>
                </h2>
                {data.bpSubtitle && (
                  <h3 className="banner-promo-blog__subTitle">
                    <span dangerouslySetInnerHTML={{ __html: data.bpSubtitle }}></span>
                  </h3>
                )}
                {data.bpAbstract && (
                  <div className="mt-4">
                    <p
                      className="banner-promo-blog__desc"
                      dangerouslySetInnerHTML={{ __html: data.bpAbstract }}
                    ></p>
                  </div>
                )}
                <Link
                  to={bpLink}
                  target={data.cta?.bpCtaTarget}
                  className="btn-link mt-3"
                  rel="noreferrer"
                >
                  {data.cta?.bpCtaLabel}
                </Link>
              </div>
            </div>
            {(getImage(data.bpImage.node) ||
              (getImage(data.bpImage.node) && data.bpPdpPosition?.[0] === "full image")) && (
              <div
                className={classNames(
                  "banner-promo-blog__wrapper p-0",
                  getImage(data.bpImage.node) && data.bpPdpPosition?.[0] === "full image"
                    ? "col-12"
                    : "col-12 col-md-6"
                )}
              >
                <GatsbyImage
                  className="prodotti__img-promo"
                  loading="eager"
                  image={getImage(data.bpImage.node)}
                  alt={data.bpImage?.value?.description || ""}
                />
              </div>
            )}
          </div>
        </div>
      </>
    ))
  );
};

export default BannerPromoCM;

export const fragment = graphql`
  fragment BannerPromoCMFragment on LiferayBannerPromo {
    bpTitle
    bpSubtitle
    bpAbstract
    bpPdpPosition
    cta {
      bpCtaLabel
      bpCtaLink
      bpCtaTarget
    }
    bpImage {
      value {
        description
      }
      node {
        gatsbyImageData(layout: FULL_WIDTH)
      }
      nodeBackground: node {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
  }
`;
